import DatePicker from '@anm/components/DatePicker';
import isMobile from '@anm/helpers/is/isMobile';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { FC } from 'react';

import { TabTitle } from '../../Wrapper';

import CallToActionChart from './CallToActionChart';
import EngagementChart from './EngagementChart';
import ExportAsCSVButton from './ExportAsCSVButton';
import NotHostedVideoWarning from './NotHostedVideoWarning';
import TotalTimePlaysChart from './TotalTimePlaysChart';
import UniquePlaysChart from './UniquePlaysChart';
import {
  ChartsWrapper,
  ContentWrapper,
  DateLabel,
  DatePickerAndButtonWrapper,
  DatePickerWrapper,
  EngagementWrapper,
  PlayerChartsContent
} from './Wrapper';
import { useDateRange, useFetchAnalytics, useIsVerticalVideo } from './hooks';
import { AnalyticsTabProps } from './types';

export const CHART_BAR_HEIGHT = 280;
export const CHART_BAR_MARGIN_RIGHT = isMobileOrIPad() ? 1 : 50;

const AnalyticsTab: FC<AnalyticsTabProps> = props => {
  useFetchAnalytics();
  const isVerticalVideo = useIsVerticalVideo();
  const [dateRange, projectCreatedTime, handleDateChange] = useDateRange();

  return (
    <ContentWrapper>
      <TabTitle title="Video analytics" />
      <DatePickerAndButtonWrapper>
        <DatePickerWrapper>
          <DateLabel title="Select time period" level={3} />
          <DatePicker
            isPreFilledList
            disableDates="future"
            defaultDates={dateRange}
            isOneCalendar={isMobile()}
            onDateApply={handleDateChange}
            lifetimeStartTime={projectCreatedTime}
          />
        </DatePickerWrapper>
        <ExportAsCSVButton />
      </DatePickerAndButtonWrapper>
      <NotHostedVideoWarning {...props} />
      <ChartsWrapper>
        <EngagementWrapper {...{ isVerticalVideo }}>
          <EngagementChart {...props} />
        </EngagementWrapper>
        <PlayerChartsContent {...{ isVerticalVideo }}>
          <UniquePlaysChart {...props} />
          <TotalTimePlaysChart {...props} />
          <CallToActionChart />
        </PlayerChartsContent>
      </ChartsWrapper>
    </ContentWrapper>
  );
};

export default AnalyticsTab;
